/*
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
import { NamedNode } from '../models.js';
import { Prefix } from '../utils/Prefix.js';
var base = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#';
export var _ontologyResource = NamedNode.getOrCreate(base);
Prefix.add('rdf', base);
var langString = NamedNode.getOrCreate(base + 'langString');
var type = NamedNode.getOrCreate(base + 'type');
var Property = NamedNode.getOrCreate(base + 'Property');
var List = NamedNode.getOrCreate(base + 'List');
var rest = NamedNode.getOrCreate(base + 'rest');
var first = NamedNode.getOrCreate(base + 'first');
var nil = NamedNode.getOrCreate(base + 'nil');
export const rdf = {
    _ontologyResource,
    langString,
    type,
    Property,
    List,
    rest,
    first,
    nil,
};
//# sourceMappingURL=rdf.js.map